export default () => {
    return {
        mounted() {
            this.intro();
            this.parallax();
        },

        intro() {
            const delay = this.$store.enterDelay + 0.3;

            if (this.$refs.blob) {
                const flood = gsap.timeline({
                    delay: delay,
                    onComplete: () => {
                        this.blob();
                    }
                });

                flood
                    .fromTo(
                        this.$refs.blob,
                        { xPercent: 50, yPercent: 100 },
                        { xPercent: 0, yPercent: 0, duration: 1.3, ease: 'quad.out' }
                    )
                    .to(this.$refs.drop, { morphSVG: this.$refs.wave, duration: 2.2, ease: 'circ.inOut' }, '<');
            }

            if (this.$refs.topoSpin) {
                gsap.to(this.$refs.topoSpin, {
                    duration: 100,
                    rotate: 360,
                    transformOrigin: '55% 55%',
                    repeat: -1,
                    ease: 'none'
                });
            }
        },

        blob() {
            const morph = gsap.timeline({
                repeat: -1,
                yoyo: true,
                defaults: {
                    ease: 'power1.inOut'
                }
            });

            morph
                .to(this.$refs.drop, { morphSVG: this.$refs.wave02, duration: 6 })
                .to(this.$refs.drop, { morphSVG: this.$refs.wave03, duration: 4 })
                .to(this.$refs.drop, { morphSVG: this.$refs.wave, duration: 5 });
        },

        parallax() {
            const parallax = gsap.timeline({
                scrollTrigger: {
                    trigger: this.$refs.hero,
                    scrub: 0.8,
                    start: 'top top',
                    end: 'bottom top'
                }
            });

            if (this.$refs.blobParallax) {
                parallax.fromTo(
                    this.$refs.blobParallax,
                    {
                        yPercent: 0
                    },
                    {
                        yPercent: 70,
                        ease: 'none'
                    },
                    '<'
                );
            }

            if (this.$refs.dots) {
                parallax.fromTo(
                    this.$refs.dots,
                    {
                        yPercent: 0
                    },
                    {
                        yPercent: 50,
                        ease: 'none'
                    },
                    '<'
                );
            }

            if (this.$refs.topo) {
                parallax.fromTo(
                    this.$refs.topo,
                    {
                        yPercent: 0,
                        rotate: 0
                    },
                    {
                        yPercent: -15,
                        rotate: -40,
                        transformOrigin: '55% 55%',
                        ease: 'none'
                    },
                    '<'
                );
            }

            if (this.$refs.content) {
                parallax.fromTo(
                    this.$refs.content,
                    {
                        yPercent: 0
                    },
                    {
                        yPercent: -70,
                        ease: 'none'
                    },
                    '<'
                );
            }
        }
    };
};
